import css from './Content.module.scss'

const Content = ({ children }) => (
  <div className={css.Container}>
    <div className={css.Content}>{children}</div>
  </div>
)

export default Content
